<template>
  <v-dialog
    v-model="dialog"
    max-width="480"
    @click:outside="cancel"
  >
    <v-card light>
      <v-card-title> Needs Generation Settings </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="text-subtitle-2 mb-1">For &amp; Idea pages</div>
          <p class="text--secondary mb-3">
            Ready once at least <strong>Min Categories</strong> categories each contain at least
            <strong>Min Templates per Category</strong> templates.
          </p>
          <v-text-field
            v-model.number="settings.minCategories"
            type="number"
            min="1"
            label="Min Categories"
            :rules="[(v) => v >= 1 || 'Must be at least 1']"
            outlined
          />
          <v-text-field
            v-model.number="settings.minTemplatesPerCategory"
            type="number"
            min="1"
            label="Min Templates per Category"
            :rules="[(v) => v >= 1 || 'Must be at least 1']"
            outlined
          />

          <v-divider class="mb-4" />

          <div class="text-subtitle-2 mb-1">Category pages</div>
          <p class="text--secondary mb-3">
            Ready once the category has at least this many templates.
          </p>
          <v-text-field
            v-model.number="settings.categoryMinTemplates"
            type="number"
            min="1"
            label="Category — Min Templates"
            :rules="[(v) => v >= 1 || 'Must be at least 1']"
            outlined
          />

          <div class="text-subtitle-2 mb-1">Make pages</div>
          <p class="text--secondary mb-3">
            Ready once the category has at least this many templates.
          </p>
          <v-text-field
            v-model.number="settings.makeMinTemplates"
            type="number"
            min="1"
            label="Make — Min Templates"
            :rules="[(v) => v >= 1 || 'Must be at least 1']"
            outlined
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          color="mcsprimary"
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NeedsGenerationSettings',
  data: () => ({
    dialog: false,
    saving: false,
    valid: false,
    settings: {
      minCategories: 6,
      minTemplatesPerCategory: 3,
      categoryMinTemplates: 20,
      makeMinTemplates: 20
    }
  }),
  methods: {
    open() {
      this.dialog = true;
      this.saving = false;
      this.$store
        .dispatch('content/getNeedsGenerationSettings')
        .then((data) => {
          if (data) {
            this.settings = data;
          }
        })
        .catch((error) => {
          this.logError(error, 'Failed loading settings');
        });
    },
    cancel() {
      this.dialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saving = true;
      this.$store
        .dispatch('content/saveNeedsGenerationSettings', this.settings)
        .then(() => {
          this.$root.$snackbarSuccess('Settings saved');
          this.dialog = false;
          this.$emit('saved');
        })
        .catch((error) => {
          this.logError(error, 'Failed saving settings');
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
